import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const deleteFAQAction = createAsyncThunk(
    'delete-FAQ',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.delete(`/support-server/api/support-knowladge?is_deleted=true`,{data})
            
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const deleteFAQSlice = createSlice({
    name: 'delete-FAQ',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(deleteFAQAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(deleteFAQAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(deleteFAQAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const deleteFAQReducer = deleteFAQSlice.reducer    